import { ECouponType } from '@common/enums/coupon.enum';
import { formatPrice } from '@common/utils/format-price/format-price.util';
import { ICoupon } from '@src/api/item-generated-api';


export const getDiscountString = (coupon: ICoupon | undefined): string => {
    if (!coupon) {
        return '';
    }

    return coupon?.discount_type === ECouponType.fixed_amount
        ? `-${formatPrice(coupon?.discount_amount || 0)}`
        : `-${coupon?.discount_percentage}%`;
};
